import React from 'react';

import useStyles from './styles';

interface Props {
    text: string;
    children?: React.ReactNode;
}

const FooterBar: React.FC<Props> = ({ text, children }) => {
    const { classes } = useStyles();

    return (
        <div className={classes.root}>
            <h1 className={classes.header}>{text}</h1>
            {children}
        </div>
    );
};

export default FooterBar;
